import { qualifyUrls } from 'routing/Routes';

const MimecastV2Routes = {
  INTEGRATIONS: {
    Mimecast: {
      ACTIVITYAPI: {
        index: '/integrations/mimecastv2',
      },
    },
  },
};

const ApiRoutes = {
  INTEGRATIONS: {
    Mimecast: {
      SAVE_INPUT: '/plugins/org.graylog.enterprise.integrations/mimecast_v2/inputs?setup_wizard=true',
      CHECK_CREDENTIALS: '/plugins/org.graylog.enterprise.integrations/mimecast_v2/check_credentials',
    },
  },
};

const DocsRoutes = {
  INTEGRATIONS: {
    Mimecast: {
      GRAYLOG_Mimecast_ACTIVITY_LOG_INPUT:
        'integrations/inputs/graylog_mimecastv2_ActivityLog_Input.html#graylog-mimecastv2-activitylog-input',
    },
  },
};

export default {
  ...qualifyUrls(MimecastV2Routes),
  unqualified: MimecastV2Routes,
};

export { DocsRoutes, ApiRoutes };
